import { getEnvValue } from 'helpers/env';

export const VERSION = getEnvValue('VITE_VERSION');
export const COMMIT = getEnvValue('VITE_COMMIT_OR_TAG');
export const BRANCH = getEnvValue('VITE_BRANCH');
